import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

const routes = [

    //LAYOUT FOR LANDING PAGES
    {
        path: '/',
        name: 'LandingPageLayout',
        component: () => import('@/layouts/LandingPageLayout.vue'),
        children: [
            {
                path: '/',
                name: 'Home',
                component: () => import('@/views/Home.vue'),
                meta: { auth: false }
            }
        ]
    },

    //LAYOUT FOR AUTH ROUTES
    {
        path: '/',
        name: 'AuthLayout',
        component: () => import('@/layouts/AuthLayout.vue'),
        children: [
            {
                path: '/login',
                name: 'Login',
                component: () => import('@/views/auth/Login.vue'),
                meta: { auth: false }
            },
            // {
            //     path: '/register',
            //     name: 'Register',
            //     component: () => import('@/views/auth/Register.vue'),
            //     meta: { auth: false }
            // }
        ]
    },

    //LAYOUT FOR APPLICATION WITH SIDEBAR
    {
        path: '/',
        name: 'SidebarLayout',
        component: () => import('@/layouts/SidebarLayout.vue'),
        children: [
            {
                path: '/dash',
                name: 'Dash',
                component: () => import('@/views/Dashboard.vue'),
                meta: { auth: true }
            }
        ]
    },

    //LAYOUT WITHOUT ANY SIDEBAR BUT HAS HEADER AND FOOTER
    {
        path: '/',
        name: 'AppLayout',
        component: () => import('@/layouts/AppLayout.vue'),
        props: true,
        children: [
            //DASHBOARD
            {
                path: '/dashboard',
                name: 'Dashboard',
                component: () => import('@/views/Dashboard.vue'),
                meta: { auth: true }
            },

            //PROFILE
            {
                path: '/profile',
                name: 'Profile',
                component: () => import('@/components/TheProfile.vue'),
                meta: { auth: true }
            },

            //CONFIGURATION
            {
                path: '/config',
                name: 'Config',
                component: () => import('@/components/TheConfig.vue'),
                meta: { auth: true },
            },

            //LEADS
            
            {
                path: '/leads/:slug?',
                name: 'Leads',
                component: () => import('@/views/modules/lead/Lead.vue'),
                meta: { auth: true },
                props: true,
            },

            //LEADS

            {
                path: '/customers',
                name: 'Customers',
                component: () => import('@/views/masters/Customer.vue'),
                meta: { auth: true },
            },

            //PACKAGE
            {
                path: '/packages',
                name: 'Packages',
                component: () => import('@/views/masters/Package.vue'),
                meta: { auth: true }
            },

            //TAGS
            {
                path: '/tags',
                name: 'Tags',
                component: () => import('@/views/masters/Tag.vue'),
                meta: { auth: true }
            },

            //USERS
            {
                path: '/users',
                name: 'Users',
                component: () => import('@/views/masters/User.vue'),
                meta: { auth: true }
            },

            //VEHICLES
            {
                path: '/vehicles',
                name: 'Vehicles',
                component: () => import('@/views/masters/Vehicle.vue'),
                meta: { auth: true }
            },

            //TRANSPORT
            {
                path: '/transports',
                name: 'Transports',
                component: () => import('@/views/masters/Transport.vue'),
                meta: { auth: true }
            },

            //SIGHTSEEING
            {
                path: '/sightseeing',
                name: 'Sightseeing',
                component: () => import('@/views/masters/Sightseeing.vue'),
                meta: { auth: true }
            },
            //HOTELS
            {
                path: '/hotels',
                name: 'Hotel',
                component: () => import('@/views/masters/Hotel.vue'),
                meta: { auth: true }
            },
            //ANNOUNCEMENT
            {
                path: '/announcements',
                name: 'Announcement',
                component: () => import('@/views/masters/Announcement.vue'),
                meta: { auth: true }
            },

            // experimental routes remove after development
            // PaymentReceipt
            {
                path: '/receipt',
                name: 'Receipt',
                component: () => import('@/components/PaymentReceipt.vue'),
                meta: { auth: true }
            },

        ]
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes
})
const masters = [
    "Packages",
    "Announcement",
    "Hotel",
    "Sightseeing",
    "Transports",
    "Vehicles",
    "Users",
    "Tags"
]
const allowedToMasters = [
    "admin",
    "general_manager",
    "team_leader",
    "area_sales_manager",
]

router.beforeEach((to, from, next) => {
    if (to.meta.auth && !store.state.auth.isAuth) {
        next({ name: 'Login' })
    } else if (masters.includes(to.name) && !allowedToMasters.includes(store.state.user.activeRole)) {
        return next({ name: from.name });
    } else next();

})

router.beforeResolve((to, from, next) => {
    NProgress.configure({ showSpinner: false });
    NProgress.start()
    next()
})

router.afterEach((to, from) => {
    NProgress.done()
})

export default router
